<template>
  <div class="landing-page">
    <div class="landing-title">
      {{ $t('text.welcome') }} {{ $store.getters[`user/displayName`] }}
    </div>
    <div>
      <div class="section-card">
        <div class="section-card-title">
          <img class="title-icon w-10" src="@/assets/image/info.png" />
          <span>{{ $t('text.useful_features') }}</span>
        </div>
        <div class="feature-container">
          <el-carousel
            :interval="7000"
            arrow="always"
            height="470px"
            :class="features.length === 1 ? 'signle-feature' : ''"
            :autoplay="autoplay"
          >
            <el-carousel-item
              v-for="feature in features"
              :key="feature.title + feature.order"
            >
              <div class="feature-item">
                <div class="feature-animation">
                  <img :src="feature.animation" />
                </div>
                <div class="feature-content">
                  <div class="feature-title">{{ feature.title }}</div>
                  <component
                    :is="feature.descComponent"
                    v-if="feature.descComponent"
                  />
                  <div class="feature-desc" v-html="feature.desc" v-else></div>
                  <el-button
                    slot="reference"
                    type="success"
                    class="feature-btn"
                    v-if="feature.showMeMoreContent"
                    @click="showMeMore(feature)"
                    >{{ $t('text.show_me_more') }}</el-button
                  >
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="section-card" v-if="p('Patients.Add')" id="quick-actions">
        <div
          class="section-card-title"
          :class="
            $store.getters[`patient/patientsCount`] === 0 ? 'red-title' : ''
          "
        >
          <img
            class="title-icon"
            :src="
              $store.getters[`patient/patientsCount`] === 0
                ? require('@/assets/image/warning.svg')
                : require('@/assets/image/quick-action-icon.png')
            "
          />
          <span>{{
            $store.getters[`patient/patientsCount`] === 0
              ? $t('text.attention')
              : $t('text.quick_actions')
          }}</span>
        </div>
        <div
          class="warn-text"
          v-if="$store.getters[`patient/patientsCount`] === 0"
        >
          {{
            $t('text.no_patient_warning', {
              patients: $firstLetterCapitalize(
                this.$store.state.locale.patients
              )
            })
          }}
        </div>
        <div
          v-for="action in quickActions"
          :key="action.title"
          class="quick-operate-item"
          @click="action.onClickAction(action.title, action.actionType)"
          v-show="p(action.permission) && action.show"
        >
          <div class="left-icon-wrapper v-h-center">
            <img
              :src="
                require('@/assets/image/quick-operation-icon/' + action.icon)
              "
              :style="{ width: action.iconWidth + 'px' }"
            />
          </div>
          <div class="right-content">
            <div class="quick-operate-title">{{ action.title }}</div>
            <div class="quick-operate-desc">{{ action.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <EditPatient ref="editPatient" />
    <InviteUserDialog ref="inviteUser" />
    <UpdatePatientDeviceAndProucts ref="updatePatientDeviceAndProucts" />
    <UpdatePatient ref="updatePatient" />
    <RemoveOrArchivePatient ref="removeOrArchivePatient" />
    <ScrollButton :lessHeightWillShow="800" />
    <CreateOrganisationDialog ref="createOrganisationDialog" />
    <addRole ref="addRole" :refreshParent="false" />
    <AddManufacturer ref="addManufacturer" />
    <LinkFacility ref="linkFacility" />

    <component
      :is="currentFeature.showMeMoreContent"
      ref="showMeMore"
      @changeAutoPlay="changeAutoPlay"
    />
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import InviteUserDialog from '@/components/manage/user/InviteUserDialog.vue'
import UpdatePatientDeviceAndProucts from '@/components/patients/quickActions/UpdatePatientDeviceAndProucts.vue'
import UpdatePatient from '@/components/patients/quickActions/UpdatePatient.vue'
import RemoveOrArchivePatient from '@/components/manage/patients/RemoveOrArchivePatient.vue'
import podDiaper from '@/components/showMeMore/dashboardLanding/podDiaper.vue'
import QuickActionsSlide from '@/components/landing/QuickActionsSlide.vue'
import ScrollButton from '@/components/ScrollButton.vue'
import CreateOrganisationDialog from '@/components/manage/organisation/CreateOrganisationDialog.vue'
import AddRole from '@/components/manage/admin/AddRole.vue'
import AddManufacturer from '@/components/manage/patients/editPatient/AddManufacturer.vue'
import LinkFacility from '@/components/manage/organisation/LinkFacility.vue'
import { patientQuickActions } from '@/const'
export default {
  data() {
    return {
      currentFeature: {},
      autoplay: true, // Whether the carousel is autoplay
      features: [
        {
          order: 0,
          title: this.$t('text.home_landing_slide1_title'),
          desc: this.$t('text.home_landing_slide1_content', {
            patient: this.$store.state.locale.patient,
            patients: this.$store.state.locale.patients
          }),
          descComponent: null,
          animation: require('@/assets/image/useful-features/home-landing/home-landing-health-portal.svg'),
          showMeMoreContent: null
        },
        {
          order: 1,
          title: this.$t('text.home_landing_slide2_title', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
          }),
          desc: this.$t('text.home_landing_slide2_content', {
            pad: this.$store.state.locale.pad,
            patient: this.$store.state.locale.patient
          }),
          descComponent: null,
          animation: require('@/assets/image/useful-features/home-landing/home-landing-smart-diaper.svg'),
          showMeMoreContent: null
        },
        {
          order: 2,
          title: this.$t('text.home_landing_slide3_title', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
          }),
          desc: this.$t('text.home_landing_slide3_content', {
            pad: this.$store.state.locale.pad,
            patient: this.$store.state.locale.patient
          }),
          descComponent: null,
          animation: require('@/assets/image/useful-features/home-landing/home-landing-pod-diaper.svg'),
          showMeMoreContent: 'podDiaper'
        },
        {
          order: 3,
          title: this.$t('text.home_landing_slide4_title', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc: this.$t('text.home_landing_slide4_content', {
            patient: this.$store.state.locale.patient
          }),
          descComponent: null,
          animation: require('@/assets/image/useful-features/home-landing/home-landing-add-patient.svg'),
          showMeMoreContent: null
        },
        {
          order: 4,
          title: this.$t('text.home_landing_slide5_title'),
          desc: null,
          descComponent: 'QuickActionsSlide',
          animation: require('@/assets/image/useful-features/home-landing/home-landing-quick-actions.svg'),
          showMeMoreContent: null
        }
      ]
    }
  },
  components: {
    EditPatient,
    InviteUserDialog,
    UpdatePatientDeviceAndProucts,
    UpdatePatient,
    RemoveOrArchivePatient,
    podDiaper,
    ScrollButton,
    QuickActionsSlide,
    CreateOrganisationDialog,
    AddRole,
    AddManufacturer,
    LinkFacility
  },
  computed: {
    quickActions() {
      let quickActions = [
        {
          title: this.$t('text.add_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.add_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.addPatient,
          icon: 'add-patient.png',
          iconWidth: 36,
          actionType: patientQuickActions.addPatient,
          permission: 'Patients.Add',
          show: true
        },
        {
          title: this.$t('text.update_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.update_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatient,
          icon: 'update-patient.png',
          iconWidth: 38,
          actionType: patientQuickActions.updatePatient,
          permission: 'Patients.Edit',
          show: this.$store.getters[`patient/patientsCount`] > 0
        },
        {
          title: this.$t('text.change_patient_products', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.change_patient_products_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'change-product.png',
          iconWidth: 36,
          actionType: patientQuickActions.changeProduct,
          permission: 'Patients.Edit',
          show: this.$store.getters[`patient/patientsCount`] > 0
        },
        {
          title: this.$t('text.reassign_pod_to_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.reassign_pod_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'reassign-pod.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignPod,
          permission: 'Patients.Edit',
          show: this.$store.getters[`patient/patientsCount`] > 0
        },
        {
          title: this.$t('text.monitor_patient_with_a_node', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.monitor_patient_with_a_node_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'assign-node.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignNode,
          permission: 'Patients.Edit',
          show: this.$store.getters[`patient/patientsCount`] > 0
        },
        {
          title: this.$t('text.remove_or_archive_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.remove_or_archive_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.removeOrArchivePatient,
          icon: 'remove-or-archive-patient.png',
          iconWidth: 34,
          actionType: null,
          permission: 'Patients.Delete',
          show: this.$store.getters[`patient/patientsCount`] > 0
        },
        {
          title: this.$t('text.invite_user'),
          desc:
            this.$t('text.invite_user_quick_action_desc_for_home_landing') +
            '.',
          onClickAction: this.inviteUser,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Users.Invite',
          show: true
        },
        {
          title: this.$t('text.create_organisation'),
          desc: this.$t('text.create_new_organisation') + '.',
          onClickAction: this.createOrganisation,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Organisations.Add',
          show: true
        },
        {
          title: this.$t('text.add_role_title'),
          desc: this.$t('text.create_new_role') + '.',
          onClickAction: this.addRole,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Organisations.RolesPermission.Add',
          show: true
        },
        {
          title: this.$t('text.add_manufacturer'),
          desc: this.$t('text.create_new_manufacturer') + '.',
          onClickAction: this.addManufacturer,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Manufacturers.Add',
          show: true
        },
        {
          title: this.$t('text.register_an_installation_id'),
          desc: this.$t('text.register_an_installation_id_desc') + '.',
          onClickAction: this.linkFacility,
          icon: 'add-user.png',
          iconWidth: 39,
          actionType: null,
          permission: 'Organisations.Edit',
          show: true
        }
      ]
      return quickActions
    }
  },
  methods: {
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    inviteUser() {
      this.$refs.inviteUser.openDialog()
    },
    updatePatient() {
      this.$refs.updatePatient.openDialog()
    },
    updatePatientDeviceAndProucts(title, actionType) {
      this.$forceUpdate()
      this.$refs.updatePatientDeviceAndProucts.openDialog(title, actionType)
    },
    removeOrArchivePatient() {
      this.$refs.removeOrArchivePatient.openDialog()
    },
    showMeMore(feature) {
      this.currentFeature = feature
      // After clicking the show more button, then pause the autoplay of the carousel
      this.changeAutoPlay(false)
      this.$nextTick(() => {
        this.$refs.showMeMore.openDialog()
      })
    },
    changeAutoPlay(autoPlay) {
      this.autoplay = autoPlay
    },
    createOrganisation() {
      this.$refs.createOrganisationDialog.openDialog()
    },
    addRole() {
      this.$refs.addRole.openDialog()
    },
    addManufacturer() {
      this.$refs.addManufacturer.openDialog()
    },
    linkFacility() {
      this.$refs.linkFacility.openDialog()
    }
  }
}
</script>
